<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-white tw-py-2">
                Vous souhaitez réaliser<br class="tw-hidden lg:tw-block">des économies ?<br>
                <p>
                    Remplissez le formulaire ci-dessous !<br>
                    Vous serez contacté <span>gratuitement</span><br>
                    et <span>sans engagement</span>
                </p>
            </div>
            <fieldset class="tw-px-3 tw-pb-3 lg:tw-px-5 lg:tw-pb-12">
                <span class="tw-text-white tw-block tw-font-bold tw-text-lg tw-pb-2">Données personnelles</span>
                <validation-provider class="tw-w-full tw-w-block" name="gender" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-gender" :class="classes">
                        <select id="input-gender" placeholder=" " v-model="gender">
                            <option disabled selected>Civilité</option>
                            <option value="monsieur">Monsieur</option>
                            <option value="madame">Madame</option>
                        </select>
                        <label :class="{ 'select-placeholder' : !gender }">
                            Civilité
                        </label>
                    </div>
                </validation-provider>
                <div class="tw-flex tw-gap-5">
                    <validation-provider class="tw-w-full tw-w-block" name="lastName" rules="required|alpha_spaces" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <input type="text"
                                id="input-lastName"
                                placeholder=" "
                                v-model="lastName"
                            >
                            <label>
                                Prénom
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="firstName" rules="required|alpha_spaces" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <input type="text"
                                id="input-firstName"
                                placeholder=" "
                                v-model="firstName"
                            >
                            <label>
                                Nom
                            </label>
                        </div>
                    </validation-provider>
                </div>
                <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'invalide' }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            id="input-email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            Email {{ errors [0]}}
                        </label>
                    </div>
                </validation-provider>
                <div class="tw-flex tw-gap-5">
                    <validation-provider class="tw-w-full tw-w-block" name="phone" rules="phone:fr" v-slot="{ classes }">
                        <div class="input-group input-group-phone" :class="classes">
                            <input type="tel"
                                id="input-phone"
                                placeholder=" "
                                v-model="phone"
                                v-mask="{mask: '9999999999', placeholder: ' '}"
                            >
                            <label>
                                Teléphone
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="mobile" rules="required|phone:fr" v-slot="{ classes }">
                        <div class="input-group input-group-mobile" :class="classes">
                            <input type="tel"
                                id="input-mobile"
                                placeholder=" "
                                v-mask="{mask: '9999999999', placeholder: ' '}"
                                v-model="mobile"
                            >
                            <label>
                                Mobile
                            </label>
                        </div>
                    </validation-provider>
                </div>
                <validation-provider class="tw-w-full tw-w-block" name="zip" rules="required|zip:fr" v-slot="{ classes }">
                    <div class="input-group input-group-zip" :class="classes">
                        <input type="tel"
                            id="input-mobile"
                            placeholder=" "
                            v-model="zip"
                        >
                        <label>
                            Postal Code
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="contact" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-contact" :class="classes">
                        <select id="input-contact" placeholder=" " v-model="contact">
                            <option disabled selected>Quand souhaitez-vous être recontacté(e)?</option>
                            <option value="9-12">Entre 9h et 12h</option>
                            <option value="12-14">Entre 12h et 14h</option>
                            <option value="14-17">Entre 14h et 17h</option>
                            <option value="17-19">Entre 17h et 19h</option>
                        </select>
                        <label :class="{ 'select-placeholder' : !contact }">
                            Quand souhaitez-vous être recontacté(e)?
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span class="tw-text-black">J'autorise {{ company }} à utiliser mes données pour me contacter conformément à sa <a href="#" @click.prevent="$store.state.modal.terms = true"><u>politique de confidentialité</u></a><sup>(3)</sup>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-4">
                    <button
                        type="submit"
                        class="btn-cta"
                        id="submit"
                        :disabled="formLoading"
                    >
                        je valide ma demande<sup>(4)</sup>
                    </button>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/zip';

export default {
    name: 'FormComponent',
    data() {
        return {
            lastName: this.$route.query.lname || '',
            firstName: this.$route.query.fname || '',
            phone: this.$route.query.phone || '',
            mobile: this.$route.query.mphone || '',
            email: this.$route.query.email || '',
            gender: this.$route.query.civilstatus || '',
            zip: this.$route.query.zip || '',
            contact: this.$route.query.call_schedule || '',
            cible: this.$route.query.cible || '',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                fname: this.firstName,
                lname: this.lastName,
                phone: '+33 ' + this.phone,
                mphone: '+33 ' + this.mobile,
                email: this.email,
                zip: this.zip,
                civilstatus: this.gender,
                call_schedule: this.contact,
                mclic: process.env.VUE_APP_MCLIC,
                cible: this.$route.query.cible,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'déjà enregistré';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
